import type { TileTerrain } from "../worldState.ts";
import {
  DEFEAT_POPULATION,
  FAMINE_STREAK_REQUIRED,
  FIRE_DURATION_TURNS_MAX,
  FIRE_DURATION_TURNS_MIN,
  FIRE_EVENT_PROBABILITY,
  FOOD_BANK_GROWTH_COST,
  FOOD_BANK_GROWTH_THRESHOLD,
  GROWTH_STREAK_REQUIRED,
  INITIAL_FOOD_SUPPLIES,
  INITIAL_POPULATION,
  INITIAL_TURN,
  TERRAIN_FOOD_PRODUCTION,
  TERRAIN_SPAWN_WEIGHTS,
  TILE_FOOD_DEPLETION_STEP,
  TILE_FOOD_MIN_YIELD_FRACTION,
  TILE_FOOD_REGEN_STEP,
  VICTORY_POPULATION,
} from "./balance.ts";

export interface WorldBalance {
  initialPopulation: number;
  initialFoodSupplies: number;
  initialTurn: number;
  victoryPopulation: number;
  defeatPopulation: number;
  foodBankGrowthThreshold: number;
  foodBankGrowthCost: number;
  growthStreakRequired: number;
  famineStreakRequired: number;
  tileFoodDepletionStep: number;
  tileFoodRegenStep: number;
  tileFoodMinYieldFraction: number;
  terrainFoodProduction: Record<TileTerrain, number>;
  terrainSpawnWeights: ReadonlyArray<{ terrain: TileTerrain; weight: number }>;
  fireEventProbability: number;
  fireDurationTurnsMin: number;
  fireDurationTurnsMax: number;
}

export const DEFAULT_WORLD_BALANCE: WorldBalance = {
  initialPopulation: INITIAL_POPULATION,
  initialFoodSupplies: INITIAL_FOOD_SUPPLIES,
  initialTurn: INITIAL_TURN,
  victoryPopulation: VICTORY_POPULATION,
  defeatPopulation: DEFEAT_POPULATION,
  foodBankGrowthThreshold: FOOD_BANK_GROWTH_THRESHOLD,
  foodBankGrowthCost: FOOD_BANK_GROWTH_COST,
  growthStreakRequired: GROWTH_STREAK_REQUIRED,
  famineStreakRequired: FAMINE_STREAK_REQUIRED,
  tileFoodDepletionStep: TILE_FOOD_DEPLETION_STEP,
  tileFoodRegenStep: TILE_FOOD_REGEN_STEP,
  tileFoodMinYieldFraction: TILE_FOOD_MIN_YIELD_FRACTION,
  terrainFoodProduction: TERRAIN_FOOD_PRODUCTION,
  terrainSpawnWeights: TERRAIN_SPAWN_WEIGHTS,
  fireEventProbability: FIRE_EVENT_PROBABILITY,
  fireDurationTurnsMin: FIRE_DURATION_TURNS_MIN,
  fireDurationTurnsMax: FIRE_DURATION_TURNS_MAX,
};

export function resolveWorldBalance(balance?: WorldBalance): WorldBalance {
  return balance ?? DEFAULT_WORLD_BALANCE;
}
